export function IsUnauthenticatedRoute(route: string) {
  const unauthenticatedRoutes = ["/password/edit"];

  return unauthenticatedRoutes.includes(route);
}
